/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable no-plusplus */
/* eslint-disable react/no-danger */
/* eslint-disable no-restricted-syntax */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/media-has-caption */
/* eslint-disable react/jsx-no-duplicate-props */
/* eslint-disable array-callback-return */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react-hooks/rules-of-hooks */
import React, { useState, useRef } from "react";
import dayjs from "dayjs";
import { makeObservable, observable, action } from "mobx";
import { Props as DataGridProps } from "../components/DataGrid/DataGrid";
import { getTemplates } from "../api/Templates";
import { UtcDateFormatter } from "../utils/dateformat/dateFormat";
import { Cookies } from "react-cookie";
// Operation 컬럼 비활성화로 미사용. 컬럼 주석과 함께 되살린다.
// import ListModerationBtn from "../pages/Moderation/ListModerationBtn";
import Avatar from "@mui/material/Avatar";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import { defaultAllCode } from "../pages/Templates/LanguageCode";
import { defaultAllCategory } from "../pages/Templates/CategoryCode";
import { getItem } from "../utils/nauth";
import { postHistory } from "../api/History";
import * as Assets from "../components/Icon/assets";
import ListReviewerBtn from "../pages/Moderation/ListReviewerBtn";
import {
  CircularProgress,
  Box,
  Card,
  CardMedia,
  Dialog,
  DialogContent,
  DialogContentText,
  Button,
  Typography,
  Link,
} from "@mui/material";
import { getTempalteDetails } from "../api/Templates";
import { DetailRequestProps } from "../api/types";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { styled } from "@mui/system";
import NoImg from "../components/Icon/assets/NoImg.png";
import useKeyPress from "../utils/custom/useKeyPress";
import GTranslateIcon from "@mui/icons-material/GTranslate";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { getAccountServerType, getTemplatesServerType } from "../constants";
import { keyframes } from "@mui/system";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";

const cookies = new Cookies();
const getCookie = (item: string) => {
  return cookies.get(item);
};
const userEmail = getItem("email") || getItem("name") || "No name";

const blink = keyframes`
  0% { opacity: 1; }
  50% { opacity: 0; }
  100% { opacity: 1; }
`;

class ModerationStore {
  constructor() {
    makeObservable(this, {
      application: observable,
      status: observable,
      startDate: observable,
      endDate: observable,
      searchText: observable,
      searchOption: observable,
      gridOption: observable,
      headerStatus: observable,
      language: observable,
      category: observable,
      mixability: observable,
      reference: observable,
      asset: observable,
      entertainment: observable,
      gacha: observable,
      isReviewer: observable,
      badge: observable,
      ratio: observable,
      isBlind: observable,
    });
  }

  application = getCookie("mApplication") ? getCookie("mApplication") : "all";
  status = getCookie("mStatus") ? getCookie("mStatus") : "Published";

  nowDate = dayjs().toDate();
  startDate = window.location.pathname.includes("userid")
    ? dayjs().subtract(1, "month").toDate()
    : getCookie("mStartDate")
    ? getCookie("mStartDate")
    : dayjs().subtract(1, "month").toDate();

  endDate: Date = window.location.pathname.includes("userid")
    ? dayjs().toDate()
    : getCookie("mEndDate")
    ? dayjs(getCookie("mEndDate"), "yyyy/MM/dd").toDate()
    : dayjs().toDate();

  searchText = "";
  searchOption = "templateId";
  headerStatus = localStorage.getItem("columns") || "";
  language = getCookie("mLanguage") ? getCookie("mLanguage") : defaultAllCode;
  category = getCookie("mCategory")
    ? getCookie("mCategory")
    : defaultAllCategory;
  mixability = getCookie("mMixability")
    ? getCookie("mMixability") === "0"
      ? 1
      : getCookie("mMixability")
    : 1;
  reference = getCookie("mReference")
    ? getCookie("mReference") === "0"
      ? 1
      : getCookie("mReference")
    : 1;

  asset = getCookie("mAsset")
    ? getCookie("mAsset") === "0"
      ? 1
      : getCookie("mAsset")
    : 1;
  entertainment = getCookie("mEntertainment")
    ? getCookie("mEntertainment") === "0"
      ? 1
      : getCookie("mEntertainment")
    : 1;
  gacha = true;
  isReviewer = false;
  badge = "none";
  ratio = getCookie("mRatio") ? getCookie("mRatio") : "all";

  isBlind = false;

  gridOption: DataGridProps = {
    columns: [
      {
        field: "index",
        headerName: "No",
        filterable: false,
        renderCell: (index) =>
          index.api.getRowIndex(index.row.id) +
          1 +
          this.gridOption.page * this.gridOption.rowsPerPage,
        width: 50,
        align: "center",
        hide: this.headerStatus.includes("index"),
      },
      {
        field: "link",
        headerName: "Link",
        width: 80,
        align: "center",
        headerAlign: "center",
        hide: this.headerStatus.includes("link"),
        renderCell: () => {
          return (
            <>
              <img
                src={Assets.NewWindows}
                alt="new window"
                style={{
                  width: 20,
                  height: 20,
                  cursor: "pointer",
                }}
              />
            </>
          );
        },
      },
      {
        field: "thumbnail",
        headerName: "Thumbnail",
        width: 640,
        headerAlign: "center",
        renderCell: (param) => {
          interface Labels {
            [key: string]: number; // 키는 문자열, 값은 숫자
          }

          const [openModerAlert, setModerAlert] = useState<boolean>(false);
          const [imageIndex, setImageIndex] = useState<number>(0);
          const userLang = navigator.language || "en";
          const [image, setImage] = useState(
            param.row.imagePath ? param.row.imagePath : NoImg
          );

          const videoRef = useRef<HTMLVideoElement | null>(null);
          const [speed, setSpeed] = useState(getCookie("videoSpeed") || 1);

          const [detailLoading, setDetailLoading] = useState<boolean>(false);
          const [appName, setAppName] = useState("");
          const [appVersion, setAppVersion] = useState("");
          const [OS, setOS] = useState("");
          const [kineInfo, setKineInfo] = useState(param.row.kineInfo);

          const [forbiddenWord, setForbiddenWord] = useState(
            param.row.forbiddenWords
          );

          const imgWidth =
            (Number(param.row.ratios.split(":")[0]) /
              Number(param.row.ratios.split(":")[1])) *
            350;

          const hentai = param.row.nsfw && Number(param.row.nsfw.hentai) * 100;
          const porn = param.row.nsfw && Number(param.row.nsfw.porn) * 100;
          const sexy = param.row.nsfw && Number(param.row.nsfw.sexy) * 100;

          const [labels, setLabels] = useState<Labels | null>(param.row.labels);

          const handleSpeedChange = (newSpeed: number) => {
            if (videoRef.current) {
              videoRef.current.playbackRate = newSpeed;
              setSpeed(newSpeed);
            }
          };

          const enlargeImage = async () => {
            const data: DetailRequestProps = {
              data: param.row.templateId,
            };
            await getTempalteDetails(data).then((res) => {
              if (res.response?.status) {
                setDetailLoading(true);
              } else {
                setAppName(res.userAgent.appName);
                setAppVersion(res.userAgent.appVersion);
                setOS(res.userAgent.os);
              }
            });
            setImageIndex(0);
            setImage(param.row.imagePath);
            setModerAlert(true);
          };

          const changeImage = (index: number) => {
            if (index === 6) {
              setImage(param.row.videoPath);
              setImageIndex(6);
            } else {
              index === 0
                ? setImage(param.row.imagePath)
                : setImage(param.row.thumbnailsPaths[index - 1]);
              setImageIndex(index);
            }
          };

          const backImage = (index: number) => {
            if (index < 0) {
              setImageIndex(6);
              setImage(param.row.videoPath);
            } else {
              setImageIndex(index);
              index === 0
                ? setImage(param.row.imagePath)
                : setImage(param.row.thumbnailsPaths[index - 1]);
            }
          };

          const forwardImage = (index: number) => {
            if (index > 6) {
              setImageIndex(0);
              setImage(param.row.imagePath);
            } else {
              setImageIndex(index === 6 ? 6 : index);
              setImage(
                index === 6
                  ? param.row.videoPath
                  : index === 0
                  ? param.row.imagePath
                  : param.row.thumbnailsPaths[index - 1]
              );
            }
          };

          const encodeString = (text: string) => {
            return encodeURIComponent(text);
          };

          const wordMatching = (text: string, forbiddenWords: any) => {
            const highlightForbiddenWords = (
              text: string,
              forbiddenWords: any
            ) => {
              let result = [];
              let startIndex = 0;

              for (let i = 0; i < text.length; i++) {
                for (const { keyword } of forbiddenWords) {
                  if (
                    text.slice(i, i + keyword.length).toLowerCase() ===
                    keyword.toLowerCase()
                  ) {
                    if (startIndex !== i) {
                      result.push(text.slice(startIndex, i));
                    }
                    result.push(
                      <b>
                        <span style={{ color: "red" }}>
                          {text.slice(i, i + keyword.length)}
                        </span>
                      </b>
                    );
                    startIndex = i + keyword.length;
                    i += keyword.length - 1;
                    break;
                  }
                }
              }

              if (startIndex < text.length) {
                result.push(text.slice(startIndex));
              }

              return result;
            };

            return (
              <div>
                {highlightForbiddenWords(text, forbiddenWords)}
                <Link
                  sx={{
                    pt: "3px",
                  }}
                  href={`https://translate.google.co.kr/?sl=auto&hl=${userLang}&text=${encodeString(
                    param.row.translations[0].description
                  )}`}
                  target="_blank"
                >
                  <GTranslateIcon
                    sx={{
                      fontSize: "large",
                      cursor: "pointer",
                      color: "#6666ff",
                      minWidth: "25px",
                    }}
                  />
                </Link>
              </div>
            );
          };

          const keywordString = (item: any) => {
            const forbiddenKeywords = item.map((word: any) => word.keyword);

            return forbiddenKeywords.join(", ");
          };

          const handleKeyDown = async (event: KeyboardEvent) => {
            let element: HTMLElement = event.target as HTMLElement;
            if (element) {
              switch (element.tagName) {
                case "INPUT":
                case "LI":
                case "TEXTAREA":
                case "BUTTON":
                  break;
                default:
                  if (event.key === "ArrowRight") {
                    forwardImage(imageIndex + 1);
                  } else if (event.key === "ArrowLeft") {
                    backImage(imageIndex - 1);
                  } else if (event.key === "Enter") {
                    setModerAlert(false);
                  }
                  break;
              }
            }
          };

          useKeyPress(
            ["ArrowRight", "ArrowLeft", "Escape", "Enter"],
            handleKeyDown
          );

          const handleEscape = (
            // 위의 handleKeyDown 함수에서 Escape(ESC 단축키)가 적용되지 않아 함수를 따로 뺴서 사용
            event: React.KeyboardEvent<HTMLDivElement>
          ) => {
            if (event.key === "Escape") {
              setModerAlert(false);
            }
          };

          const ImageCard = styled(Card)({
            "&.selectedImage": {
              border: "2px solid red",
            },
          });

          const ImageCardMedia = styled(CardMedia)({
            "&.selectedImage": {
              border: "2px solid red",
            },
          });

          return (
            <>
              <Box>
                <Box
                  style={{
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  {param.row.thumbnailsPaths &&
                  param.row.thumbnailsPaths.length > 0 ? (
                    param.row.thumbnailsPaths.map(
                      (item: any, index: number) => {
                        return (
                          <>
                            <div
                              key={"div" + index}
                              style={{
                                maxWidth: "120px",
                                height: "100%",
                                display: "flex",
                                alignItems: "center",
                                cursor: "pointer",
                              }}
                              onClick={enlargeImage}
                            >
                              <img
                                style={{
                                  height: "calc(100% - 10px)",
                                  maxHeight: "160px",
                                  maxWidth: "120px",
                                }}
                                src={item}
                                key={"img" + index}
                              />
                            </div>
                            &nbsp;
                          </>
                        );
                      }
                    )
                  ) : (
                    <div
                      style={{
                        height: "100%",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <img
                        style={{
                          height: "calc(100% - 10px)",
                          maxWidth: "120px",
                        }}
                        src={NoImg}
                      />
                    </div>
                  )}
                </Box>
                <Box
                  sx={{
                    maxWidth: "620px",
                    display: "flex",
                  }}
                >
                  <Typography
                    sx={{
                      overflow: "hidden",
                      whiteSpace: "nowrap",
                      textOverflow: "ellipsis",
                      maxWidth: "590px",
                    }}
                  >
                    {forbiddenWord ? (
                      wordMatching(
                        param.row.translations[0].description.trim(),
                        forbiddenWord
                      )
                    ) : (
                      <>
                        Description :{" "}
                        {param.row.translations[0].description.trim()}
                      </>
                    )}
                  </Typography>
                  <Link
                    sx={{
                      pt: "3px",
                    }}
                    href={`https://translate.google.co.kr/?sl=auto&hl=${userLang}&text=${encodeString(
                      param.row.translations[0].description
                    )}`}
                    target="_blank"
                  >
                    <GTranslateIcon
                      sx={{
                        fontSize: "large",
                        cursor: "pointer",
                        color: "#6666ff",
                        minWidth: "25px",
                      }}
                    />
                  </Link>
                </Box>
                {forbiddenWord && (
                  <Box>
                    <Typography
                      sx={{
                        overflow: "hidden",
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis",
                        maxWidth: "590px",
                      }}
                    >
                      Forbidden Word :{" "}
                      <b style={{ color: "red" }}>
                        {keywordString(forbiddenWord)}
                      </b>
                    </Typography>
                  </Box>
                )}
              </Box>

              <Dialog
                open={openModerAlert}
                onKeyDown={handleEscape}
                PaperProps={{ id: "openedDlg" }}
                sx={{
                  "& .MuiDialog-container": {
                    "& .MuiPaper-root": {
                      width: "1400px",
                      maxWidth: "1400px",
                      height: "930px",
                      maxHeight: "930px",
                    },
                  },
                }}
              >
                <DialogContent>
                  <Box>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "right",
                        pb: "10px",
                      }}
                    >
                      <Typography sx={{ width: "30%" }}>
                        UID:{" "}
                        <Link
                          href={
                            getAccountServerType() + "/" + param.row.author.sub
                          }
                          target="_blank"
                        >
                          {param.row.author.sub}
                        </Link>
                      </Typography>
                      <Typography sx={{ width: "30%" }}>
                        Nickname: {param.row.author.name}
                      </Typography>
                      <Typography sx={{ width: "30%" }}>
                        <Link
                          href={
                            getTemplatesServerType() +
                            "templates/userid/" +
                            param.row.author.sub
                          }
                          target="_blank"
                        >
                          Uploaded Template
                        </Link>
                      </Typography>
                      <HighlightOffIcon
                        sx={{ cursor: "pointer" }}
                        onClick={() => {
                          setModerAlert(false);
                        }}
                      />
                    </Box>
                  </Box>

                  <Box>
                    <DialogContentText
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        mt: imgWidth < 200 ? "15px" : "70px",
                      }}
                    >
                      <Box
                        sx={{
                          width: "48px",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <ArrowBackIosIcon
                          sx={{ cursor: "pointer" }}
                          onClick={() => backImage(imageIndex - 1)}
                        />
                      </Box>
                      &nbsp;
                      <Box
                        sx={{
                          width: "700px", // 고정된 너비
                          height: "350px", // 고정된 높이
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        {imageIndex > 5 ? (
                          <video
                            style={{
                              maxWidth: "700px",
                              width: imgWidth,
                              height: "350px",
                            }}
                            controls
                            autoPlay
                            ref={videoRef}
                          >
                            <source src={image} type="video/mp4" />
                          </video>
                        ) : (
                          <img
                            style={{
                              maxWidth: "700px",
                              width: imgWidth,
                              height: "350px",
                              border: "1px solid",
                            }}
                            src={image}
                          />
                        )}
                      </Box>
                      &nbsp;
                      <Box
                        sx={{
                          width: "48px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "right",
                        }}
                      >
                        <ArrowForwardIosIcon
                          sx={{ cursor: "pointer" }}
                          onClick={() => forwardImage(imageIndex + 1)}
                        />
                      </Box>
                    </DialogContentText>
                    <DialogContentText
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      {imageIndex > 5 ? (
                        <>
                          <Box
                            sx={{
                              textAlign: "center",
                              margin: "0 auto",
                              pt: 1,
                            }}
                          >
                            VIDEO
                            {[1, 2, 3, 4].map((speedOption) => (
                              <Button
                                sx={{
                                  pl: "0px",
                                  pr: "0px",

                                  minWidth: "25px !important",
                                  width: "25px !important",
                                  "&&.Mui-disabled": {
                                    color: "#6750A4",
                                    fontSize: "17px",
                                  },
                                  height: "17px",
                                }}
                                key={speedOption}
                                onClick={() => handleSpeedChange(speedOption)}
                                disabled={speed === speedOption}
                              >
                                {speed === speedOption ? (
                                  <b>{speedOption + "x"}</b>
                                ) : (
                                  `${speedOption}x`
                                )}
                              </Button>
                            ))}
                          </Box>
                        </>
                      ) : (
                        <Typography sx={{ pt: 1 }}>
                          {" "}
                          {imageIndex === 0
                            ? "Thumbnail"
                            : `Snapshot# ${Number(imageIndex)}`}
                        </Typography>
                      )}
                    </DialogContentText>
                    <DialogContentText
                      sx={{
                        mt: "10px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <Box
                        sx={{
                          width: "128px", // 고정된 너비
                          height: imgWidth < 200 ? "215px" : "145px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <ImageCard
                          style={{
                            height: "calc(100% - 5px)",
                            maxWidth: "120px",
                            minWidth: "120px",
                            boxShadow: "none", // box-shadow 제거
                            marginRight: "5px",
                          }}
                        >
                          <CardMedia
                            component="img"
                            className={imageIndex === 0 ? "selectedImage" : ""}
                            src={param.row.imagePath}
                            sx={{
                              border: imageIndex === 0 ? "2px solid red" : "",
                            }}
                            onClick={() => changeImage(0)}
                          />
                        </ImageCard>
                        {param.row.thumbnailsPaths &&
                          param.row.thumbnailsPaths.map(
                            (item: any, index: number) => {
                              return (
                                <>
                                  {
                                    <ImageCard
                                      key={index + 1}
                                      style={{
                                        height: "calc(100% - 5px)",
                                        maxWidth: "120px",
                                        minWidth: "120px",
                                        boxShadow: "none", // box-shadow 제거
                                      }}
                                    >
                                      <CardMedia
                                        component="img"
                                        className={
                                          imageIndex === index + 1
                                            ? "selectedImage"
                                            : ""
                                        }
                                        sx={{
                                          border:
                                            imageIndex === index + 1
                                              ? "2px solid red"
                                              : "",
                                        }}
                                        src={item}
                                        onClick={() => changeImage(index + 1)}
                                      />
                                    </ImageCard>
                                  }
                                  &nbsp;
                                </>
                              );
                            }
                          )}

                        <ImageCard
                          key={6}
                          className={imageIndex === 6 ? "selectedImage" : ""}
                          style={{
                            height: `${
                              (Number(param.row.ratios.split(":")[1]) /
                                Number(param.row.ratios.split(":")[0])) *
                              120
                            }px`,
                            maxWidth: "120px",
                            minWidth: "120px",
                            paddingTop: "30px",
                            alignSelf: "flex-start",
                            marginTop: "1px",
                            position: "relative",
                          }}
                          onClick={() => changeImage(6)}
                        >
                          <CardMedia
                            component="img"
                            sx={{
                              width: "40px",
                              height: "40px",
                              position: "absolute",
                              top: "50%",
                              left: "50%",
                              transform: "translate(-50%, -50%)",
                              cursor: "pointer",
                            }}
                            src={Assets.PlayButton}
                          />
                        </ImageCard>
                      </Box>
                    </DialogContentText>

                    <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
                      <Box
                        className="use-scrollbar"
                        sx={{
                          flex: 1,
                          maxWidth: "570px",
                          height: "180px",
                          ml: 15,
                          overflowY: "scroll", // 수직 스크롤바를 항상 표시
                          whiteSpace: "pre-wrap",
                        }}
                      >
                        <DialogContentText
                          sx={{
                            display: "flex",
                            justifyContent: "left",
                          }}
                        >
                          <Typography sx={{ minWidth: "100px" }}>
                            <b>Description</b>:
                          </Typography>

                          <Typography>
                            {forbiddenWord
                              ? wordMatching(
                                  param.row.translations[0].description,
                                  forbiddenWord
                                )
                              : `${param.row.translations[0].description}`}
                          </Typography>
                        </DialogContentText>

                        {kineInfo.complexity ? (
                          <>
                            <DialogContentText
                              sx={{
                                display: "flex",
                                justifyContent: "left",
                              }}
                            >
                              <b>
                                Template Resource:{" "}
                                {kineInfo.complexity?.videoClipCount +
                                  kineInfo.complexity?.imageClipCount +
                                  kineInfo.complexity?.audioClipCount +
                                  kineInfo.complexity?.transitionCount +
                                  kineInfo.complexity?.layerVideoCount +
                                  kineInfo.complexity?.layerImageCount +
                                  kineInfo.complexity?.layerTextCount +
                                  kineInfo.complexity?.layerHandwritingCount +
                                  kineInfo.complexity?.layerAssetCount}
                              </b>
                            </DialogContentText>
                            <DialogContentText
                              sx={{
                                display: "flex",
                                justifyContent: "left",
                              }}
                            >
                              - Clip{" "}
                              {kineInfo.complexity?.videoClipCount +
                                kineInfo.complexity?.imageClipCount +
                                kineInfo.complexity?.audioClipCount +
                                kineInfo.complexity?.transitionCount}
                              : Video({kineInfo.complexity?.videoClipCount}
                              ), Image Clip(
                              {kineInfo.complexity?.imageClipCount}
                              ), Audio({kineInfo.complexity?.audioClipCount}),
                              Transition(
                              {kineInfo.complexity?.transitionCount})
                            </DialogContentText>
                            <DialogContentText
                              sx={{
                                display: "flex",
                                justifyContent: "left",
                              }}
                            >
                              - Layer{" "}
                              {kineInfo.complexity?.layerVideoCount +
                                kineInfo.complexity?.layerImageCount +
                                kineInfo.complexity?.layerTextCount +
                                kineInfo.complexity?.layerHandwritingCount +
                                kineInfo.complexity?.layerAssetCount}
                              : Video(
                              {kineInfo.complexity?.layerVideoCount}
                              ), Image({kineInfo.complexity?.layerImageCount}),
                              Asset(
                              {kineInfo.complexity?.layerAssetCount}), Text(
                              {kineInfo.complexity?.layerTextCount}),
                              Handwriting(
                              {kineInfo.complexity?.layerHandwritingCount})
                            </DialogContentText>
                          </>
                        ) : (
                          <>
                            <DialogContentText
                              sx={{
                                display: "flex",
                                justifyContent: "left",
                              }}
                            >
                              <b>Template Resource</b> : Data not exist
                            </DialogContentText>
                          </>
                        )}

                        <DialogContentText
                          sx={{
                            display: "flex",
                            justifyContent: "left",
                          }}
                        >
                          {detailLoading ? (
                            <>
                              <Box sx={{ minWidth: "120px" }}>
                                <b>Application</b>:{" "}
                                <CircularProgress
                                  size="1rem"
                                  sx={{ mt: "6px" }}
                                />
                              </Box>
                              <Box sx={{ minWidth: "120px" }}>
                                <b>App Version</b>:{" "}
                                <CircularProgress
                                  size="1rem"
                                  sx={{ mt: "6px" }}
                                />
                              </Box>

                              <Box sx={{ minWidth: "120px" }}>
                                <b>OS</b>:{" "}
                                <CircularProgress
                                  size="1rem"
                                  sx={{ mt: "6px" }}
                                />
                              </Box>
                            </>
                          ) : (
                            <>
                              <Box>
                                <b>Application</b>:{" "}
                                {appName === "kinemaster"
                                  ? "KineMaster"
                                  : "Spring"}{" "}
                              </Box>
                              &nbsp;&nbsp;
                              <Box>
                                <b>App Version</b>: {appVersion}{" "}
                              </Box>
                              &nbsp;&nbsp;
                              <Box>
                                {" "}
                                <b>OS</b>: {OS}
                              </Box>
                            </>
                          )}
                        </DialogContentText>
                      </Box>
                      <Box
                        className="use-scrollbar"
                        sx={{
                          flex: 1,
                          maxWidth: "570px",
                          height: "180px",
                          overflowY: "scroll", // 수직 스크롤바를 항상 표시
                          whiteSpace: "pre-wrap",
                          ml: 1,
                        }}
                      >
                        <DialogContentText
                          sx={{
                            display: "flex",
                            justifyContent: "left",
                          }}
                        >
                          <Typography sx={{ minWidth: "150px" }}>
                            <b>Forbidden Word</b>:
                          </Typography>
                          {forbiddenWord ? (
                            <Typography sx={{ color: "red" }}>
                              <b>{keywordString(forbiddenWord)}</b>
                            </Typography>
                          ) : (
                            <Typography>None</Typography>
                          )}
                        </DialogContentText>
                        <DialogContentText
                          sx={{
                            display: "flex",
                            justifyContent: "left",
                          }}
                        >
                          <Box display="flex" alignItems="center" marginTop={1}>
                            <Typography sx={{ minWidth: "60px" }}>
                              <b>NSFW</b>
                            </Typography>
                            <Box
                              sx={{
                                width: 13,
                                height: 13,
                                backgroundColor: "red",
                                mr: 1,
                                ml: 2,
                              }}
                            />
                            <Typography
                              sx={{ marginRight: 1, fontSize: "13px" }}
                            >
                              Warning
                            </Typography>
                            <Box
                              sx={{
                                width: 13,
                                height: 13,
                                backgroundColor: "black",
                                marginRight: 1,
                              }}
                            />
                            <Typography sx={{ fontSize: "13px" }}>
                              Normal
                            </Typography>
                          </Box>
                        </DialogContentText>
                        {param.row.nsfw ? (
                          <>
                            <DialogContentText
                              sx={{
                                display: "flex",
                                justifyContent: "left",
                                ml: "10px",
                              }}
                            >
                              <Box display="flex" alignItems="center">
                                <Typography sx={{ minWidth: "100px" }}>
                                  Hentai
                                </Typography>
                                <Box
                                  sx={{
                                    width: 15,
                                    height: 15,
                                    backgroundColor:
                                      hentai >= 80 ? "red" : "black",
                                    marginRight: 1,
                                    animation:
                                      hentai >= 80
                                        ? `${blink} 1s infinite`
                                        : "none",
                                  }}
                                />{" "}
                                <Typography
                                  sx={{
                                    color:
                                      Number(hentai) >= 80 ? "red" : "inherit",
                                    animation:
                                      Number(hentai) >= 80
                                        ? `${blink} 1s infinite`
                                        : "none",
                                  }}
                                >
                                  {hentai.toFixed(1)}%
                                </Typography>
                              </Box>
                            </DialogContentText>
                            <DialogContentText
                              sx={{
                                display: "flex",
                                justifyContent: "left",
                                ml: "10px",
                              }}
                            >
                              <Box display="flex" alignItems="center">
                                <Typography sx={{ minWidth: "100px" }}>
                                  Porn
                                </Typography>
                                <Box
                                  sx={{
                                    width: 15,
                                    height: 15,
                                    backgroundColor:
                                      porn >= 90 ? "red" : "black",
                                    marginRight: 1,
                                    animation:
                                      porn >= 90
                                        ? `${blink} 1s infinite`
                                        : "none",
                                  }}
                                />{" "}
                                <Typography
                                  sx={{
                                    color: porn >= 90 ? "red" : "inherit",
                                    animation:
                                      porn >= 90
                                        ? `${blink} 1s infinite`
                                        : "none",
                                  }}
                                >
                                  {porn.toFixed(1)}%
                                </Typography>
                              </Box>
                            </DialogContentText>
                            <DialogContentText
                              sx={{
                                display: "flex",
                                justifyContent: "left",
                                ml: "10px",
                              }}
                            >
                              <Box display="flex" alignItems="center">
                                <Typography sx={{ minWidth: "100px" }}>
                                  Sexy
                                </Typography>
                                <Box
                                  sx={{
                                    width: 15,
                                    height: 15,
                                    backgroundColor:
                                      sexy >= 50 ? "red" : "black",
                                    marginRight: 1,
                                    animation:
                                      sexy >= 50
                                        ? `${blink} 1s infinite`
                                        : "none",
                                  }}
                                />{" "}
                                <Typography
                                  sx={{
                                    color: sexy >= 50 ? "red" : "inherit",
                                    animation:
                                      sexy >= 50
                                        ? `${blink} 1s infinite`
                                        : "none",
                                  }}
                                >
                                  {sexy.toFixed(1)}%
                                </Typography>
                              </Box>
                            </DialogContentText>
                          </>
                        ) : (
                          <Typography sx={{ color: "#00000099" }}>
                            None
                          </Typography>
                        )}
                        {(
                          <>
                            <DialogContentText
                              sx={{
                                display: "flex",
                                justifyContent: "left",
                                mt: 1,
                              }}
                            >
                              <Typography sx={{ minWidth: "150px" }}>
                                <b>AI Moderation</b>:
                              </Typography>
                              <Typography
                                sx={{
                                  fontWeight: "bold",
                                  color:
                                    param.row.aiReview?.moderation?.result ===
                                    "Published"
                                      ? "#1976D2"
                                      : param.row.aiReview?.moderation?.result ===
                                        "Rejected"
                                      ? "#B3261E"
                                      : "inherit",
                                }}
                              >
                                {param.row.aiReview?.moderation?.result ?? "N/A"}
                              </Typography>
                            </DialogContentText>
                            <DialogContentText
                              sx={{
                                display: "flex",
                                justifyContent: "left",
                              }}
                            >
                              <Typography sx={{ minWidth: "150px" }}>
                                <b>AI Age Rating</b>:
                              </Typography>
                              <Typography>
                                {param.row.aiReview?.ageRating?.minAge != null
                                  ? `${param.row.aiReview.ageRating.minAge}+`
                                  : "N/A"}
                              </Typography>
                            </DialogContentText>
                            <DialogContentText
                              sx={{
                                display: "flex",
                                justifyContent: "left",
                              }}
                            >
                              <Typography sx={{ minWidth: "150px" }}>
                                <b>AI Quality Score</b>:
                              </Typography>
                              <Typography sx={{ fontWeight: "bold" }}>
                                {param.row.aiReview?.quality?.totalScore != null
                                  ? param.row.aiReview.quality.totalScore
                                  : "N/A"}
                              </Typography>
                            </DialogContentText>
                          </>
                        )}
                      </Box>
                    </Box>
                    <DialogContentText
                      sx={{ display: "flex", justifyContent: "center" }}
                    >
                      <Button
                        sx={{ p: "2.5px", position: "absolute", top: "880px" }}
                        variant="outlined"
                        onClick={() => {
                          setModerAlert(false);
                        }}
                      >
                        Close
                      </Button>
                    </DialogContentText>
                  </Box>
                </DialogContent>
              </Dialog>
            </>
          );
        },
        hide: this.headerStatus.includes("thumbnail"),
      },
      {
        field: "langAndRegion",
        headerName: "Lang/Region",
        width: 130,
        align: "center",
        headerAlign: "center",
      },
      {
        field: "reviewStatus",
        headerName: "Status",
        width: 140,
        align: "center",
        headerAlign: "center",
        hide: this.headerStatus.includes("reviewer"),
        renderCell: (param) => {
          return (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {param.row.isBlind ? (
                <Typography style={{ display: "flex", alignItems: "center" }}>
                  {param.row.reviewStatus}
                  <VisibilityOffIcon
                    style={{
                      marginLeft: "5px",
                      marginTop: "2px",
                      color: "#79747e",
                    }}
                  />
                </Typography>
              ) : (
                <Typography>{param.row.reviewStatus}</Typography>
              )}
            </div>
          );
        },
      },
      {
        field: "reviewer",
        headerName: "Reviewer",
        width: 140,
        renderCell: (param) => {
          if (
            param.row.reviewStatus === "In Review" &&
            param.row.reviewer === ""
          ) {
            return (
              <div
                style={{
                  height: "100%",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <ListReviewerBtn template={param.row} />
              </div>
            );
          } else if (
            param.row.reviewStatus === "Published" &&
            param.row.reviewer === ""
          ) {
            return (
              <div
                style={{
                  height: "100%",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Avatar
                  alt="KineMaster"
                  src="https://resource.kinemaster.com/www/favicon.ico"
                />
              </div>
            );
          } else {
            return param.row.reviewer;
          }
        },
        hide: this.headerStatus.includes("reviewer"),
      },
      {
        field: "createdAt",
        headerName: "Uploaded Date",
        width: 240,
        align: "center",
        headerAlign: "center",
        hide: this.headerStatus.includes("createdAt"),
        renderHeader: (params) => {
          return (
            <div
              style={{
                fontWeight: "500",
                display: "flex",
                alignItems: "center",
              }}
            >
              {/* 특정 헤더를 커스텀 렌더링합니다. */}
              {params.colDef.headerName}

              {this.gridOption.sort === "desc" ? (
                <ArrowUpwardIcon
                  fontSize="small"
                  style={{ marginLeft: "5px" }}
                />
              ) : (
                <ArrowDownwardIcon
                  fontSize="small"
                  style={{ marginLeft: "5px" }}
                />
              )}
            </div>
          );
        },
      },
      // 사용하지 않아 비활성화한 Operation 컬럼. 이 컬럼이 ListModerationBtn
      // (행별 Publish / Reject / Blind 버튼)의 유일한 렌더 지점이므로, 되살릴 때
      // 아래 import 주석도 함께 되살려야 한다.
      // {
      //   field: "operation",
      //   headerName: "Operation",
      //   width: 150,
      //   align: "center",
      //   headerAlign: "center",
      //   hide: this.headerStatus.includes("link"),
      //   renderCell: (param) => {
      //     return <ListModerationBtn template={param.row} />;
      //   },
      // },
    ],

    rows: [],
    totalCount: 0,
    loading: true,
    page: Number(getCookie("mPage")) ? Number(getCookie("mPpage")) : 0,
    rowsPerPage: Number(getCookie("mRowsPerPage"))
      ? Number(getCookie("mRowsPerPage"))
      : 50,
    sort: getCookie("mSort") ? getCookie("mSort") : "desc",
  };

  setApplication = action((application: string) => {
    this.application = application;
  });

  setStatus = action((status: string) => {
    this.status = status;
  });

  setMixability = action((mixability: number) => {
    this.mixability = mixability;
  });

  setReference = action((reference: number) => {
    this.reference = reference;
  });

  setAsset = action((asset: number) => {
    this.asset = asset;
  });

  setEntertainment = action((entertainment: number) => {
    this.entertainment = entertainment;
  });

  setStartDate = action((startDate: Date) => {
    this.startDate = startDate;
  });

  setEndDate = action((endDate: Date) => {
    this.endDate = endDate;
  });

  setSearchText = action((searchText: string) => {
    if (searchText.slice(0, 1) !== " ") {
      this.searchText = searchText;
    }
  });

  setSearchOption = action((searchOption: string) => {
    this.searchOption = searchOption;
  });

  setGridOption = action((gridOption: any) => {
    this.gridOption = {
      ...this.gridOption,
      ...gridOption,
    };
  });
  setLanguageChange = action((value: any) => {
    this.language = value;
  });

  setCategoryChange = action((category: any) => {
    this.category = category;
  });

  setGacha = action((gacha: boolean) => {
    this.gacha = gacha;
  });

  setIsReviewer = action((isReviewer: boolean) => {
    this.isReviewer = isReviewer;
  });

  setBadge = action((badge: any) => {
    this.badge = badge;
  });

  setRatio = action((ratio: any) => {
    this.ratio = ratio;
  });

  setIsBlind = action((blind: boolean) => {
    this.isBlind = blind;
  });

  onPageSizeChange = action((params: any) => {
    window.scrollTo(0, 0);
    this.gridOption.rowsPerPage = params;
  });

  onPageChange = action((params: any) => {
    window.scrollTo(0, 0);
    this.gridOption.page = params;
  });

  get getGridStatus() {
    return {
      page: this.gridOption.page + 1,
      display: this.gridOption.rowsPerPage,
      startedAt: this.startDate,
      endedAt: this.endDate,
      reviewStatus: this.status !== "All" ? this.status : undefined,
      searchType: this.searchText !== "" ? this.searchOption : undefined,
      searchText: this.searchText !== "" ? this.searchText : undefined,
    };
  }

  setRows = action(async () => {
    if (this.searchOption === "reviewer") {
      if (!this.searchText.includes("@") || !this.searchText.includes(".")) {
        alert("Please enter the full name including the domain.");
        return;
      }
    }

    this.setIsBlind(this.status === "Blind" ? true : false);

    const requestParameter = {
      page: this.gridOption.page + 1,
      display: this.gridOption.rowsPerPage,
      startedAt: this.startDate,
      endedAt: this.endDate,
      reviewStatus:
        this.status !== "All"
          ? this.status === "Blind"
            ? undefined
            : this.status
          : undefined,
      searchType: this.searchText !== "" ? this.searchOption : undefined,
      searchText:
        this.searchText.trim() !== "" ? this.searchText.trim() : undefined,
      sort: this.gridOption.sort,
      language: this.language.value,
      category: this.category.value,
      mixability: this.mixability !== 0 ? this.mixability : undefined,
      reference: this.reference !== 0 ? this.reference : undefined,
      asset: this.asset !== 0 ? this.asset : undefined,
      entertainment: this.entertainment !== 0 ? this.entertainment : undefined,
      application: this.application !== "all" ? this.application : "",
      ratio: this.ratio !== "all" ? this.ratio : "",
      isBlind: this.isBlind,
    };
    this.searchText = this.searchText.trim();
    this.gridOption.loading = true;
    this.gridOption.rows = [];

    // if (this.status === "All") {
    const blindParameter = {
      page: this.gridOption.page + 1,
      display: this.gridOption.rowsPerPage,
      startedAt: this.startDate,
      endedAt: this.endDate,
      reviewStatus: undefined,
      searchType: this.searchText !== "" ? this.searchOption : undefined,
      searchText:
        this.searchText.trim() !== "" ? this.searchText.trim() : undefined,
      sort: this.gridOption.sort,
      language: this.language.value,
      category: this.category.value,
      mixability: this.mixability !== 0 ? this.mixability : undefined,
      reference: this.reference !== 0 ? this.reference : undefined,
      asset: this.asset !== 0 ? this.asset : undefined,
      entertainment: this.entertainment !== 0 ? this.entertainment : undefined,
      application: this.application !== "all" ? this.application : "",
      ratio: this.ratio !== "all" ? this.ratio : "",
      isBlind: true,
    };

    const allList: any[] = [
      getTemplates(requestParameter),
      getTemplates(blindParameter),
    ];
    await Promise.all(allList)
      .then((item) => {
        // Axios 는 실패해도 throw 하지 않고 에러 객체를 그대로 반환한다(=> Promise.all 도
        // 정상 resolve 한다). 정상 응답에만 있는 필드로 판별해 catch 로 넘긴다.
        // item[1] 은 blind merge 용 두 번째 호출 — 이쪽만 실패해도 병합 결과가 틀어진다.
        if (!item[0]?.templates || !item[1]?.templates) {
          throw item[0]?.templates ? item[1] : item[0];
        }
        const templateMap = new Map();
        const blindTemplateIds = new Set();
        const resultList: any[] = [];

        // 첫 번째 API 결과 처리
        item[0].templates.forEach((template: any) => {
          templateMap.set(template.templateId, {
            ...template,
            isBlind: false,
          });
        });

        // 두 번째 API 결과 처리 - blind 처리된 항목 ID 저장
        item[1].templates.forEach((template: any) => {
          blindTemplateIds.add(template.templateId);
        });

        // 모든 템플릿에 대해 blind 여부 확인
        templateMap.forEach((template) => {
          const isBlind = blindTemplateIds.has(template.templateId);

          // 모든 템플릿에 isBlind 속성 추가
          resultList.push({
            ...template,
            isBlind,
          });
        });

        this.setGridOption({
          totalCount: item[0].totalCount,
          rows: resultList.map((info: any) => {
            const reviewer = info.reviewer.split("@");
            return {
              ...info,
              id: info.templateId,
              thumbnail: info.imagePath,
              description: info.translations[0].description,
              createdAt: UtcDateFormatter(info.createdAt),
              userId: info.author.sub,
              name: info.author.name,
              lang: info.metaLanguageCode,
              langAndRegion: `${info.metaLanguageCode} / ${
                info.metaCountryCode.length >= 249
                  ? "All Country"
                  : info.metaCountryCode
              }`,
              reviewStatus:
                info.reviewStatus === "InReview"
                  ? "In Review"
                  : info.reviewStatus,
              reviewer: reviewer[0],
            };
          }),
        });
      })
      .catch((error) => {
        console.log("error", error);
        this.gridOption.totalCount = 0;
        const status = error?.response?.status;
        alert(
          `Failed to load the moderation list.${status ? ` (code: ${status})` : ""}`
        );
      })
      .finally(() => {
        this.gridOption.loading = false;
      });
  });

  searchHandler = action(async () => {
    // 검색어 없을시 모달을 띄울것인가?
    this.gridOption.page = 0;
    await this.setRows();
  });
}

export default ModerationStore;
